import {
  ArrowRight, Inbox, Send, Video, FileText, MessageCircle, Globe,
  XCircle, UserPlus, Link2, CheckCircle2, MessageSquare,
} from 'lucide-react';
import { fmtDate } from './api';

const ACTIVITY_STYLE = {
  email_raus:        { icon: Send,          bg: 'bg-[#EBF4FD]',          color: 'text-[#338edc]',                  label: 'E-Mail gesendet' },
  email_rein:        { icon: Inbox,         bg: 'bg-[#ECFEFF]',          color: 'text-[#0891B2]',                  label: 'E-Mail empfangen' },
  meeting:           { icon: Video,         bg: 'bg-[#FFF7ED]',          color: 'text-[#EA580C]',                  label: 'Meeting' },
  notiz:             { icon: FileText,      bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-secondary)]',    label: 'Notiz' },
  stage_wechsel:     { icon: ArrowRight,    bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-tertiary)]',     label: 'Status-Wechsel' },
  chat_nachricht:    { icon: MessageCircle, bg: 'bg-[#EBF4FD]',          color: 'text-[#338edc]',                  label: 'Chat-Nachricht' },
  lead_eingegangen:  { icon: Inbox,         bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-secondary)]',    label: 'Lead eingegangen' },
  zuweisung:         { icon: UserPlus,      bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-secondary)]',    label: 'Owner zugewiesen' },
  website_analyse:   { icon: Globe,         bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-secondary)]',    label: 'Website-Analyse' },
  workflow_stop:     { icon: XCircle,       bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-tertiary)]',     label: 'Workflow gestoppt' },
  aufgabe:           { icon: CheckCircle2,  bg: 'bg-[var(--bg-inset)]',  color: 'text-[var(--text-secondary)]',    label: 'Aufgabe' },
  chat_link_erstellt:{ icon: Link2,         bg: 'bg-[#EBF4FD]',          color: 'text-[#338edc]',                  label: 'Chat-Link erstellt' },
};

const DEFAULT_STYLE = { icon: MessageSquare, bg: 'bg-[var(--bg-inset)]', color: 'text-[var(--text-secondary)]', label: 'Aktivität' };

export default function ActivitiesTab({ aktivitaeten = [] }) {
  const events = aktivitaeten.filter((a) => a.typ !== 'email_rein' && a.typ !== 'email_raus');

  if (events.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-10 text-[var(--text-tertiary)]">
        <MessageSquare className="w-8 h-8 mb-2 opacity-50" />
        <span className="text-[13px]">Noch keine Aktivitäten</span>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {events.map((a) => {
        const style = ACTIVITY_STYLE[a.typ] || DEFAULT_STYLE;
        const Icon = style.icon;
        return (
          <div key={a.id} className="flex gap-3 px-3 py-2 rounded-lg hover:bg-[var(--bg-inset)]">
            <div className={`w-7 h-7 rounded-full ${style.bg} flex items-center justify-center flex-shrink-0 mt-0.5`}>
              <Icon className={`w-3.5 h-3.5 ${style.color}`} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <span className="text-[12px] font-medium text-[var(--text-primary)]">{style.label}</span>
                <span className="text-[11px] text-[var(--text-tertiary)] flex-shrink-0">{fmtDate(a.erstellt_am)}</span>
              </div>
              {a.inhalt && <p className="text-[12px] text-[var(--text-secondary)] mt-0.5 whitespace-pre-wrap line-clamp-3">{a.inhalt}</p>}
              {a.erstellt_von_name && <span className="text-[11px] text-[var(--text-tertiary)]">von {a.erstellt_von_name}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
